<!--
 * @Author: yuanjianlong
 * @Description: 组件展示
 * @Date: 2021-12-01 11:19:24
 * @LastEditTime: 2021-12-13 15:13:05
 * @FilePath: /teacher-h5/src/demo/pagination.vue
-->
<template>
  <div class="h-full p-20 bg-gray-10">
    <div>
      <h1 class="text-h32 mb-20">
        Pagination 分页
      </h1>
      <div>
        <div class="mb-20">
          <h1>基本</h1>
          <a-pagination v-model="current" :total="50" show-less-items />
          <h1>更多分页</h1>
          <a-pagination v-model="current" :total="500" />
          <h1>改变每页显示条目数</h1>
          <a-pagination
            show-size-changer
            :default-current="3"
            :total="500"
            @showSizeChange="onShowSizeChange"
          />
          <h1>size: small</h1>
          <a-pagination
            show-size-changer
            :default-current="3"
            :total="500"
            size="small"
            @showSizeChange="onShowSizeChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      current: 3
    }
  },
  methods: {
    onChange(page, pageSize) {
      console.log('onChange', page, pageSize)
    },
    onShowSizeChange(current, pageSize) {
      console.log('onShowSizeChange', current, pageSize)
    },
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return <a><i class="iconfont icon-arrowLeft"></i></a>
      } else if (type === 'next') {
        return <a><i class="iconfont icon-arrowRight"></i></a>
      } else if (type === 'jump-prev') {
        return <a><i class="iconfont icon-more"></i></a>
      } else if (type === 'jump-next') {
        return <a><i class="iconfont icon-more"></i></a>
      }
      return originalElement
    }
  }
}
</script>

<style>
</style>